import type { Location } from "react-router"
import { normalizePathname } from "@exxatdesignux/ui/lib/nav-active"

export type ExamManagementNavOrigin = "course-offerings" | "assessments"

const EXAM_MANAGEMENT_ASSESSMENT_DETAIL =
  /^\/exam-management\/assessments\/[^/]+/

const EXAM_MANAGEMENT_COURSE_ASSESSMENT_DETAIL =
  /^\/exam-management\/course-offerings\/[^/]+\/assessments\/[^/]+/

const EXAM_MANAGEMENT_ASSESSMENTS_HUB = "/exam-management/assessments"
const EXAM_MANAGEMENT_COURSE_OFFERINGS_HUB = "/exam-management/course-offerings"

export function isExamManagementAssessmentDetailPath(pathname: string): boolean {
  const normalized = normalizePathname(pathname)
  return (
    EXAM_MANAGEMENT_COURSE_ASSESSMENT_DETAIL.test(normalized) ||
    EXAM_MANAGEMENT_ASSESSMENT_DETAIL.test(normalized)
  )
}

/** Where the user entered the assessment detail flow from (sidebar highlight). */
export function resolveExamManagementNavOrigin(
  location: Location,
): ExamManagementNavOrigin {
  const state = location.state as { navOrigin?: ExamManagementNavOrigin } | null
  if (state?.navOrigin === "assessments") return "assessments"
  return "course-offerings"
}

/**
 * Assessment detail routes are shared URLs; sidebar active state follows entry
 * context so course-scoped work keeps Course Offerings highlighted.
 */
export function examManagementNavActiveOverride(
  pathname: string,
  url: string,
  location: Location | null,
): boolean | null {
  if (!location) return null
  const normalized = normalizePathname(pathname)
  // Nested course URLs already prefix-match Course Offerings. Override only
  // leftover flat `/assessments/:id` visits that still carry course origin.
  if (EXAM_MANAGEMENT_COURSE_ASSESSMENT_DETAIL.test(normalized)) return null
  if (!EXAM_MANAGEMENT_ASSESSMENT_DETAIL.test(normalized)) return null
  if (resolveExamManagementNavOrigin(location) === "assessments") return null

  if (url === EXAM_MANAGEMENT_ASSESSMENTS_HUB) return false
  if (url === EXAM_MANAGEMENT_COURSE_OFFERINGS_HUB) return true
  return null
}

export const examManagementAssessmentNavState = (
  origin: ExamManagementNavOrigin,
) => ({ navOrigin: origin })
